// Acesso aos 6 endpoints do indicador de Lead Time de Fatura
// (PO1-3000 / PO1-3001). Ficam num módulo só para a tela não repetir a rota e
// para o contrato ter um lugar único onde é lido.
//
// Escopo de embarcador NUNCA vai na query: o backend resolve pelo JWT / header
// X-Active-Embarcador-Id. A tela manda só período, campo de data e (quando há)
// transportadora — os MESMOS filtros da Auditoria de Faturas, porque as duas
// telas medem a mesma coorte.

import api from "services/api";

const BASE = "/faturas/conferencia/lead-time";

/**
 * Filtros da coorte no formato aceito por `montarFiltrosConferencia`.
 * `dataCampo=integracao` é o mesmo recorte dos ciclos concluídos da H1.
 * `volume`, `executores` e `motivos` EXIGEM dataDe/dataAte (400 sem eles).
 */
export const montarParams = ({ desde, ate, idTransportadora }) => {
  const params = {
    dataCampo: "integracao",
    dataDe: desde,
    dataAte: ate,
  };
  if (idTransportadora) params.idTransportadora = idTransportadora;
  return params;
};

export const buscarResumo = (params) =>
  api.get(BASE, { params }).then((res) => res.data);

export const buscarVolume = (params, granularidade) =>
  api
    .get(`${BASE}/volume`, { params: { ...params, granularidade } })
    .then((res) => res.data);

export const buscarExecutores = (params) =>
  api.get(`${BASE}/executores`, { params }).then((res) => res.data);

export const buscarMotivos = (params) =>
  api.get(`${BASE}/motivos`, { params }).then((res) => res.data);

export const buscarAging = (params) =>
  api.get(`${BASE}/aging`, { params }).then((res) => res.data);

export const baixarExportXlsx = (params, granularidade) =>
  api
    .get(`${BASE}/export`, {
      params: { ...params, granularidade },
      responseType: "blob",
    })
    .then((res) => res.data);

// Mensagem de erro do backend (string ou mapa de erros do Yup) em uma linha.
// O `fallback` vem ANTES de `error.message` de propósito: ele nomeia a seção
// que falhou ("Erro ao carregar os motivos de bloqueio"), enquanto o message do
// axios é sempre o mesmo "Request failed with status code 500" — inútil dentro
// de um card que já perdeu o conteúdo.
export const mensagemErro = (error, fallback) => {
  const corpo = error && error.response && error.response.data;
  const detalhe = corpo && corpo.error;

  if (typeof detalhe === "string" && detalhe) return detalhe;
  if (detalhe && typeof detalhe === "object") {
    const partes = Object.keys(detalhe).map((k) => `${k}: ${detalhe[k]}`);
    if (partes.length) return partes.join("; ");
  }

  return fallback || (error && error.message);
};

/**
 * O export vem como blob; quando o backend recusa (400 do teto de 50.000, por
 * exemplo) o corpo é um JSON DENTRO do blob. Sem ler o blob a tela mostraria
 * "falha ao gerar" e esconderia justamente a instrução ("Refine os filtros").
 */
export const mensagemErroBlob = (error, fallback) =>
  new Promise((resolve) => {
    const corpo = error && error.response && error.response.data;
    if (!corpo || typeof Blob === "undefined" || !(corpo instanceof Blob)) {
      resolve(mensagemErro(error, fallback));
      return;
    }

    const reader = new FileReader();
    reader.onload = () => {
      try {
        const json = JSON.parse(String(reader.result));
        const detalhe = json && json.error;
        if (typeof detalhe === "string" && detalhe) return resolve(detalhe);
        if (detalhe && typeof detalhe === "object") {
          const partes = Object.keys(detalhe).map((k) => `${k}: ${detalhe[k]}`);
          if (partes.length) return resolve(partes.join("; "));
        }
      } catch (e) {
        // Blob que não é JSON: cai no fallback.
      }
      return resolve(fallback);
    };
    reader.onerror = () => resolve(fallback);
    reader.readAsText(corpo);
  });
